import { API_PREFIX, paginatedFromDto, type HttpClient } from "@nasam/kernel";
import type { RolesRepository } from "../domain";
import {
  messageResponseDtoSchema,
  roleMutationResponseDtoSchema,
  roleResponseDtoSchema,
  rolesListResponseDtoSchema,
  roleWriteDtoSchema,
} from "./rolesDtos";
import { roleFromDto, roleToDto } from "./rolesMappers";

const TEMPLATES_PATH = `${API_PREFIX}/templates`;

export function createRolesHttpRepository(http: HttpClient): RolesRepository {
  return {
    async list(query) {
      const response = await http.get(TEMPLATES_PATH, { params: query });
      return paginatedFromDto(
        rolesListResponseDtoSchema.parse(response),
        roleFromDto,
      );
    },
    async getById(id) {
      const response = await http.get(`${TEMPLATES_PATH}/${id}`);
      return roleFromDto(roleResponseDtoSchema.parse(response).data);
    },
    async create(input) {
      const response = await http.post(
        TEMPLATES_PATH,
        roleWriteDtoSchema.parse(roleToDto(input)),
      );
      return roleFromDto(roleMutationResponseDtoSchema.parse(response).data);
    },
    async update(id, input) {
      const response = await http.put(
        `${TEMPLATES_PATH}/${id}`,
        roleWriteDtoSchema.parse(roleToDto(input)),
      );
      return roleFromDto(roleMutationResponseDtoSchema.parse(response).data);
    },
    async delete(id) {
      const response = await http.delete(`${TEMPLATES_PATH}/${id}`);
      messageResponseDtoSchema.parse(response);
    },
  };
}
